import { MAX_REQUEST_RETRIES } from '../constants';
import { HttpError, NormalizedError } from '../errors';

export const retryRequestExceptForClientErrors = <TError>(retryAttempt: number, error: TError) => {
  if (retryAttempt >= MAX_REQUEST_RETRIES) {
    return false;
  }

  const isClientError = error instanceof HttpError && error.statusCode >= 400 && error.statusCode < 500;
  if (error instanceof NormalizedError || isClientError) {
    return false;
  }

  return true;
};
